
import moment from 'moment';
import 'moment/locale/zh-cn';

// time(秒) MM月DD日 ddd
export function formatTime(time) {
  time = time * 1000;

  return moment(time).local('zh-cn').format('MM月DD日 ddd');
}

// time(秒) MM月DD日
export function formatTime2(time) {
  time = time * 1000;

  return moment(time).local('zh-cn').format('MM月DD日');
}

// time(秒) MM月DD日
export function formatTime3(time) {
  time = time * 1000;

  return moment(time).local('zh-cn').format('ddd');
}



// WEBPACK FOOTER //
// ./src/helpers/trip/format.js